import { __module as l } from "../../../../_virtual/interopRequireWildcard.mjs";
import "./typeof.mjs";
import { exports as s } from "../../../../_virtual/typeof.mjs";
(function(o) {
  var u = s.default;
  function f(r) {
    if (typeof WeakMap != "function")
      return null;
    var a = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
    return (f = function(p) {
      return p ? t : a;
    })(r);
  }
  function c(r, a) {
    if (!a && r && r.__esModule)
      return r;
    if (r === null || u(r) != "object" && typeof r != "function")
      return {
        default: r
      };
    var t = f(a);
    if (t && t.has(r))
      return t.get(r);
    var e = {
      __proto__: null
    }, p = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var n in r)
      if (n !== "default" && {}.hasOwnProperty.call(r, n)) {
        var i = p ? Object.getOwnPropertyDescriptor(r, n) : null;
        i && (i.get || i.set) ? Object.defineProperty(e, n, i) : e[n] = r[n];
      }
    return e.default = r, t && t.set(r, e), e;
  }
  o.exports = c, o.exports.__esModule = !0, o.exports.default = o.exports;
})(l);
//# sourceMappingURL=interopRequireWildcard.mjs.map
